export default __webpack_public_path__ + "images/logo_delpfine_invert_no_bg.6e8534cf.webp";